import { useIsMediaLibrary } from 'hooks/use-is-media-library';
import { useMediaFilesQuery } from './use-media-files-query';
// import { useMockFilesQuery } from './use-mock-files-query';
import { useDocumentFilesQuery } from './use-document-manager';

export type FileManagerType = 'media' | 'document' | 'shared';

export interface FileManagerConfig {
  type: FileManagerType;
  queryHook: (params: any, extraParams?: any) => any;
  actions: {
    viewDetails: boolean;
    download: boolean;
    share: boolean;
    delete: boolean;
    rename: boolean;
    sharedWithTenant?: boolean;
  };
  defaultViewMode: 'grid' | 'list';
}

export const useFileManagerConfig = (type?: FileManagerType): FileManagerConfig => {
  const isMediaLibrary = useIsMediaLibrary();
  const finalType = type ?? (isMediaLibrary ? 'media' : 'document');

  switch (finalType) {
    case 'media':
      return {
        type: 'media',
        queryHook: useMediaFilesQuery,
        actions: {
          viewDetails: true,
          download: true,
          share: false,
          delete: false,
          rename: false,
        },
        defaultViewMode: 'grid',
      };
    case 'shared':
      return {
        type: 'shared',
        queryHook: useDocumentFilesQuery,
        actions: {
          viewDetails: true,
          download: true,
          share: false,
          delete: false,
          rename: false,
        },
        defaultViewMode: 'list',
      };
    case 'document':
    default:
      return {
        type: 'document',
        queryHook: useDocumentFilesQuery,
        actions: {
          viewDetails: true,
          download: true,
          share: true,
          delete: true,
          rename: true,
          sharedWithTenant: true,
        },
        defaultViewMode: 'list',
      };
  }
};
